<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="费用名称"
      edit-title
      id-key="CostId"
      :data="data"
      form-label-width="120px"
      @create-opened="onCreateOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="费用类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="费用编码" prop="CostNo">
          <span v-if="Mode == 0" class="detail-span">{{ data.CostNo }}</span>
          <el-input v-else v-model="data.CostNo" placeholder="请输入费用编码"></el-input>
        </el-form-item>
        <el-form-item label="费用名称" prop="CostName">
          <el-input v-model="data.CostName" placeholder="请输入费用名称" />
        </el-form-item>
        <el-form-item label="默认票据类型" prop="InvoiceType">
          <invoice-select v-model="data.InvoiceType" :clearable="false" />
        </el-form-item>
        <el-form-item label="费用项目" prop="ItemName">
          <item-select v-model="data.ItemName" init @select="select" />
        </el-form-item>
        <el-form-item label="关联单据类型" prop="SourceTypeId">
          <source-select v-model="data.SourceTypeId" :clearable="false" />
        </el-form-item>
        <el-form-item label="是否分摊">
          <el-checkbox v-model="data.IsShare" class="detail-span"></el-checkbox>
        </el-form-item>
        <el-form-item label="分摊方式" v-show="data.IsShare">
          <el-select v-model="data.ShareMode" placeholder="请选择分摊方式">
            <el-option label="按金额" :value="0"></el-option>
            <el-option label="按数量" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <!-- <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.CostNo" placeholder="请输入费用编码" />
        </el-form-item> -->
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import typeSelect from './type/select'
import sourceSelect from '@/components/basedata/basedoc/billtype/select'
import invoiceSelect from '@/components/basedata/finance/invoice/select'
import itemSelect from '@/components/basedata/finance/expenseitems/select'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    sourceSelect,
    invoiceSelect,
    itemSelect
  },
  data() {
    return {
      data: {
        CostId: 0,
        CostNo: '',
        CostName: '',
        ClassId: 0,
        ItemId: '',
        ItemName: '',
        InvoiceType: '',
        InvoiceTypeName: '',
        SourceTypeId: '',
        IsShare: 0, //是否分摊
        ShareMode: 0, //分摊方式，0:按金额、1:按数量
        Sn: 0,
        Status: 1
      },
      Mode: 0,
      api: require('@/api/ba/cost').default,
      code_api: require('@/api/sy/serialCode').default,
      rules: {
        CostNo: [{ required: true, message: '费用编码不能为空' }],
        CostName: [{ required: true, message: '费用名称不能为空' }],
        ClassId: [{ required: true, message: '请选择费用类别' }],
        Sn: [{ required: true, message: '序号不能为空' }]
      }
    }
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn(this.data.ClassId || 0).then(res => {
        this.data.Sn = res
      })

      this.code_api.previewNo('费用').then(res => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.CostNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取费用编号失败')
        }
      })
    },
    select(data) {
      this.data.ItemId = data.ItemId
    }
  }
}
</script>